import { Box, IconButton, Paper, styled, Typography } from '@mui/material';

import { colors } from '../../../../theme';
import { Colors } from '../../../../utils/Colors';

export const StyledPaper = styled(Paper)({
    backgroundColor: Colors.black2,
    borderRadius: 2,
    padding: 24
});

export const Title = styled(Typography)({
    color: Colors.white90,
    font: '600 14px Inter',
    marginBottom: 24
});

export const IterationContainer = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    marginBottom: 16
});

export const IterationTitle = styled(Typography)({
    color: Colors.white90,
    font: '600 13px Inter',
    marginBottom: 16
});

export const CompletedTask = styled(Box)({
    color: Colors.white70,
    backgroundColor: Colors.white07,
    marginBottom: 8,
    fontSize: '0.875rem',
    lineHeight: 1.5,
    borderRadius: 4,
    padding: '8px 12px'
});

export const TaskHeader = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 16
});

export const TaskTitle = styled(Typography)({
    fontWeight: 500,
    minWidth: 'fit-content',
    whiteSpace: 'nowrap'
});

export const AttachmentsWrapper = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    flex: 1,
    overflow: 'auto',
    minWidth: 0
});

export const AcceptedTaskButton = styled(Box)({
    backgroundColor: colors.tuna,
    color: Colors.white90,
    padding: '4px 12px',
    borderRadius: 20,
    fontSize: 12,
    fontWeight: 500,
    cursor: 'default',
    minWidth: 'fit-content',
    whiteSpace: 'nowrap',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6
});

// Chevron-only toggle: clicking the rest of the header does not expand/collapse,
// only the chevron does (matches the agreed UX).
export const ChevronButton = styled(IconButton, {
    shouldForwardProp: (prop) => prop !== 'expanded'
})<{ expanded?: boolean }>(({ expanded }) => ({
    padding: 4,
    color: Colors.white70,
    transition: 'transform 150ms ease',
    transform: expanded ? 'rotate(90deg)' : 'rotate(0deg)',
    '&:hover': {
        color: Colors.white90,
        backgroundColor: Colors.white10
    }
}));

export const DescriptionContainer = styled(Box)({
    marginTop: 12,
    paddingTop: 12,
    borderTop: `1px solid ${Colors.white10}`,
    color: Colors.white90
});

// Group the chevron and the title so the parent `space-between` keeps them
// glued together on the left edge with a small consistent gap.
export const LeadingGroup = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    minWidth: 0,
    flexShrink: 0
});
